<template>
    <div class="flex flex-col lg:flex-row">
        <div class="w-full filters lg:w-88">
            <div class="flex flex-col items-center mb-8 lg:hidden">
                <div class="relative w-full lg:w-2/3">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        class="absolute w-6 h-6 top-3 left-3"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                    </svg>
                    <input
                        type="text"
                        class="w-full form-input"
                        style="padding-left: 3rem !important"
                        id="search_sm"
                        v-model="filters.search"
                        :placeholder="trans.get('data.search_by_name')"
                        autocomplete="off"
                        @keyup.enter="paginationChangePage"
                        @input="paginationChangePage"
                    />
                    <button
                        v-if="filters.search"
                        class="absolute cursor-pointer right-3 top-4"
                        @mousedown.prevent.stop="filters.search = null"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-5 h-5"
                            viewBox="0 0 18 18"
                        >
                            <g
                                fill="none"
                                fill-rule="evenodd"
                                stroke="#053633"
                                stroke-width="1.5"
                            >
                                <circle cx="9" cy="9" r="8.325" />
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M5.4,9 L12.6,9 M9,5.4 L9,12.6"
                                    transform="rotate(45 9 9)"
                                />
                            </g>
                        </svg>
                    </button>
                </div>
            </div>

            <div v-if="! is_limited_member" class="mb-8 hidden lg:block">
                <a class="px-6 py-4 bg-green-200 rounded-md inline-block" :href="`${$prefix}/observations/create`">
                    <svg class="icon icon-default w-6 h-6 mr-2 inline-block align-middle" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z">
                        </path>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>
                    <div class="inline-block align-middle">{{ trans.get("navs.main_nav.add_observation") }}</div>
                </a>
            </div>

            <div @click.prevent="showFilters = !showFilters">
                <div
                    class="flex items-center justify-between mb-6 text-3xl font-light text-green-800 md:text-6xl lg:mb-0"
                >
                    <div class="flex items-center">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="35"
                            height="36"
                        >
                            <g fill="none" fill-rule="evenodd">
                                <path d="M-47-138h1440v1633H-47z" />
                                <g stroke="#053633" stroke-width="1.5">
                                    <path
                                        stroke-linecap="round"
                                        d="M6.50000086 12.75l3.64285714 4.3M24.1428571 5.85L20.5 10.35M24.5000009 34.5l4.6428571-4.9M1.6875 5.5h31.625M1.6875 29.5h31.625M1.6875 17.5h31.625"
                                    />
                                    <path
                                        d="M16.23305878.7674558c.11649749 1.4314054-.3726517 2.9029733-1.467739 3.9981488-1.09500329 1.0950915-2.56633965 1.58424273-3.99837856 1.46714019-.11649749-1.43140539.3726517-2.90297329 1.467739-3.99814879C13.32968351 1.1395044 14.80101987.6503532 16.23305878.7674558zM21.7669412 22.2325442c-.1164975-1.4314054.3726517-2.9029733 1.467739-3.9981488 1.0950033-1.0950915 2.5663397-1.5842427 3.9983786-1.4671402.1164975 1.4314054-.3726517 2.9029733-1.467739 3.9981488-1.0950033 1.0950916-2.5663397 1.5842428-3.9983786 1.4671402zM16.2330588 34.2325442c.1164975-1.4314054-.3726517-2.9029733-1.467739-3.9981488-1.0950033-1.0950915-2.5663397-1.58424273-3.9983786-1.46714019-.1164975 1.43140539.3726517 2.90297329 1.467739 3.99814879 1.0950033 1.0950916 2.5663397 1.5842428 3.9983786 1.4671402z"
                                        fill="#F9F3EB"
                                    />
                                </g>
                            </g>
                        </svg>
                        <span class="pl-3">{{
                            trans.get('data.filters')
                        }}</span>
                    </div>
                    <div
                        class="flex items-center px-3 py-2 bg-white border border-green-800 lg:hidden"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            class="w-7 h-7"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="1.5"
                                d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
                            />
                        </svg>
                    </div>
                </div>
            </div>
            <transition name="fade">
                <div
                    :class="{
                        'mt-2 ml-2 lg:block': true,
                        hidden: !showFilters
                    }"
                >
                    <div class="py-6">
                        <div class="flex items-center">
                            <div>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 30 29"
                                >
                                    <g
                                        fill="none"
                                        fill-rule="evenodd"
                                        transform="translate(1 .5)"
                                    >
                                        <rect
                                            width="28.644"
                                            height="4.557"
                                            y="3.906"
                                            fill="#212121"
                                        />
                                        <rect
                                            width="27.342"
                                            height="18.879"
                                            x=".651"
                                            y="8.463"
                                            stroke="#212121"
                                            stroke-width=".93"
                                        />
                                        <rect
                                            width="3.255"
                                            height="6.51"
                                            x="7.812"
                                            fill="#F9F3EB"
                                            stroke="#212121"
                                            stroke-width=".93"
                                        />
                                        <rect
                                            width="3.255"
                                            height="6.51"
                                            x="16.926"
                                            fill="#F9F3EB"
                                            stroke="#212121"
                                            stroke-width=".93"
                                        />
                                        <line
                                            x1=".325"
                                            x2="28.318"
                                            y1="13.345"
                                            y2="13.345"
                                            stroke="#212121"
                                            stroke-linecap="square"
                                            stroke-width=".93"
                                        />
                                        <line
                                            x1=".325"
                                            x2="28.318"
                                            y1="17.902"
                                            y2="17.902"
                                            stroke="#212121"
                                            stroke-linecap="square"
                                            stroke-width=".93"
                                        />
                                        <line
                                            x1=".325"
                                            x2="28.318"
                                            y1="22.459"
                                            y2="22.459"
                                            stroke="#212121"
                                            stroke-linecap="square"
                                            stroke-width=".93"
                                        />
                                        <line
                                            x1="6.184"
                                            x2="6.184"
                                            y1="27.342"
                                            y2="7.812"
                                            stroke="#212121"
                                            stroke-linecap="square"
                                            stroke-width=".93"
                                        />
                                        <line
                                            x1="12.043"
                                            x2="12.043"
                                            y1="27.342"
                                            y2="7.812"
                                            stroke="#212121"
                                            stroke-linecap="square"
                                            stroke-width=".93"
                                        />
                                        <line
                                            x1="17.251"
                                            x2="17.251"
                                            y1="27.342"
                                            y2="7.812"
                                            stroke="#212121"
                                            stroke-linecap="square"
                                            stroke-width=".93"
                                        />
                                        <line
                                            x1="22.459"
                                            x2="22.459"
                                            y1="27.342"
                                            y2="7.812"
                                            stroke="#212121"
                                            stroke-linecap="square"
                                            stroke-width=".93"
                                        />
                                    </g>
                                </svg>
                            </div>
                            <date-pick
                                class="ml-4 form-input"
                                v-model="filters.from_date"
                                :inputAttributes="{
                                    readonly: true,
                                    id: 'from_date',
                                    placeholder: trans.get(
                                        'data.date.start_date'
                                    )
                                }"
                                :format="'MM/DD/YYYY'"
                                :isDateDisabled="getDisabledDates"
                                :selectableYearRange="10"
                                :startWeekOnSunday="true"
                                :weekdays="this.getShortWeekdays()"
                                :months="this.getMonths()"
                            ></date-pick>
                            <date-pick
                                id="to_date"
                                v-model="filters.to_date"
                                class="form-input"
                                :inputAttributes="{
                                    readonly: true,
                                    id: 'to_date',
                                    placeholder: trans.get(
                                        'data.date.end_date'
                                    ),
                                    class: 'border-l-0'
                                }"
                                :format="'MM/DD/YYYY'"
                                :isDateDisabled="getDisabledDates"
                                :selectableYearRange="10"
                                :startWeekOnSunday="true"
                                :weekdays="this.getShortWeekdays()"
                                :months="this.getMonths()"
                            ></date-pick>
                        </div>
                        <div
                            class="mt-2 ml-9"
                            v-if="filters.from_date || filters.to_date"
                        >
                            <button
                                @click.prevent="paginationChangePage"
                                class="px-6 py-1 mt-2 text-sm font-light tracking-wider text-white bg-green-800 border rounded-md font-sans-secondary"
                            >
                                {{ trans.get('strings.plants.apply') }}
                            </button>
                            <button
                                @click.prevent="
                                    filters.from_date = null;
                                    filters.to_date = null;
                                    paginationChangePage();
                                "
                                class="px-6 py-1 mt-2 text-sm font-light tracking-wider font-sans-secondary"
                            >
                                {{ trans.get('strings.plants.clear') }}
                            </button>
                        </div>
                    </div>
                    <div class="border-b-2"></div>

                    <div class="py-4">
                        <div
                            class="flex items-center"
                            @click.prevent="
                                showRegionObservedFilter = !showRegionObservedFilter
                            "
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                v-show="!showRegionObservedFilter"
                            >
                                <g
                                    fill="none"
                                    fill-rule="evenodd"
                                    stroke="#053633"
                                    stroke-linecap="square"
                                    stroke-width="1.5"
                                    transform="translate(1 1)"
                                >
                                    <line
                                        x1="7.65"
                                        x2="7.65"
                                        y1=".45"
                                        y2="15.75"
                                    />
                                    <line x1="15.3" y1="8.1" y2="8.1" />
                                </g>
                            </svg>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="2"
                                viewBox="0 0 18 2"
                                v-show="showRegionObservedFilter"
                            >
                                <line
                                    x1="15.3"
                                    y1="9.35"
                                    y2="9.35"
                                    fill="none"
                                    stroke="#053633"
                                    stroke-linecap="square"
                                    stroke-width="1.5"
                                    transform="translate(1 -8.5)"
                                />
                            </svg>
                            <h5 class="ml-4 font-light text-gray-600">
                                {{ trans.get('data.region_observed') }}
                            </h5>
                        </div>
                        <transition name="fade">
                            <div
                                v-show="showRegionObservedFilter"
                                class="mt-2 ml-2"
                            >
                                <multiselect
                                    id="states"
                                    v-model="filters.state_id"
                                    :options="states_options"
                                    label="label"
                                    track-by="label"
                                    :placeholder="
                                        trans.get('data.search_states')
                                    "
                                    :multiple="true"
                                    :show-labels="false"
                                >
                                    <template
                                        slot="singleLabel"
                                        slot-scope="props"
                                    >
                                        <span class="option__desc">
                                            <span class="option__title">{{
                                                props.option.label
                                            }}</span>
                                            <span
                                                class="option__remove"
                                                @mousedown.prevent.stop="
                                                    clearSelection('state_id')
                                                "
                                                >&times;</span
                                            >
                                        </span>
                                    </template>
                                </multiselect>
                                <div v-if="filters.state_id.length">
                                    <button
                                        @click.prevent="paginationChangePage"
                                        class="px-6 py-1 mt-2 text-sm font-light tracking-wider text-white bg-green-800 border rounded-md font-sans-secondary"
                                    >
                                        {{ trans.get('strings.plants.apply') }}
                                    </button>
                                    <button
                                        @click.prevent="
                                            filters.state_id = [];
                                            paginationChangePage();
                                        "
                                        class="px-6 py-1 mt-2 text-sm font-light tracking-wider font-sans-secondary"
                                    >
                                        {{ trans.get('strings.plants.clear') }}
                                    </button>
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div class="border-b-2"></div>

                    <div class="py-4">
                        <div
                            class="flex items-center"
                            @click.prevent="
                                showPlantGroupFilter = !showPlantGroupFilter
                            "
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                v-show="!showPlantGroupFilter"
                            >
                                <g
                                    fill="none"
                                    fill-rule="evenodd"
                                    stroke="#053633"
                                    stroke-linecap="square"
                                    stroke-width="1.5"
                                    transform="translate(1 1)"
                                >
                                    <line
                                        x1="7.65"
                                        x2="7.65"
                                        y1=".45"
                                        y2="15.75"
                                    />
                                    <line x1="15.3" y1="8.1" y2="8.1" />
                                </g>
                            </svg>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="2"
                                viewBox="0 0 18 2"
                                v-show="showPlantGroupFilter"
                            >
                                <line
                                    x1="15.3"
                                    y1="9.35"
                                    y2="9.35"
                                    fill="none"
                                    stroke="#053633"
                                    stroke-linecap="square"
                                    stroke-width="1.5"
                                    transform="translate(1 -8.5)"
                                />
                            </svg>
                            <h5 class="ml-4 font-light text-gray-600">
                                {{ trans.get('data.plant_group') }}
                            </h5>
                        </div>
                        <transition name="fade">
                            <div
                                v-show="showPlantGroupFilter"
                                class="mt-2 ml-2"
                            >
                                <div
                                    class="flex my-2"
                                    v-for="plantGroup in plantGroupsOptions"
                                    :key="plantGroup.id"
                                >
                                    <input
                                        :id="plantGroup.id"
                                        class="mr-1 form-checkbox"
                                        type="checkbox"
                                        :value="plantGroup.id"
                                        v-model="filters.plant_groups"
                                    />
                                    <label
                                        class="ml-2 font-light text-gray-600"
                                        :for="plantGroup.id"
                                        >{{ plantGroup.label }}
                                    </label>
                                </div>
                                <div v-if="filters.plant_groups.length">
                                    <button
                                        @click.prevent="paginationChangePage"
                                        class="px-6 py-1 mt-2 text-sm font-light tracking-wider text-white bg-green-800 border rounded-md font-sans-secondary"
                                    >
                                        {{ trans.get('strings.plants.apply') }}
                                    </button>
                                    <button
                                        @click.prevent="
                                            filters.plant_groups = [];
                                            paginationChangePage();
                                        "
                                        class="px-6 py-1 mt-2 text-sm font-light tracking-wider font-sans-secondary"
                                    >
                                        {{ trans.get('strings.plants.clear') }}
                                    </button>
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div class="border-b-2"></div>
                    <div class="py-4">
                        <div
                            class="flex items-center"
                            @click.prevent="
                                showObservationTypeFilter = !showObservationTypeFilter
                            "
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 18 18"
                                v-show="!showObservationTypeFilter"
                            >
                                <g
                                    fill="none"
                                    fill-rule="evenodd"
                                    stroke="#053633"
                                    stroke-linecap="square"
                                    stroke-width="1.5"
                                    transform="translate(1 1)"
                                >
                                    <line
                                        x1="7.65"
                                        x2="7.65"
                                        y1=".45"
                                        y2="15.75"
                                    />
                                    <line x1="15.3" y1="8.1" y2="8.1" />
                                </g>
                            </svg>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="2"
                                viewBox="0 0 18 2"
                                v-show="showObservationTypeFilter"
                            >
                                <line
                                    x1="15.3"
                                    y1="9.35"
                                    y2="9.35"
                                    fill="none"
                                    stroke="#053633"
                                    stroke-linecap="square"
                                    stroke-width="1.5"
                                    transform="translate(1 -8.5)"
                                />
                            </svg>
                            <h5 class="ml-4 font-light text-gray-600">
                                {{ trans.get('data.observation_type') }}
                            </h5>
                        </div>
                        <transition name="fade">
                            <div
                                v-show="showObservationTypeFilter"
                                class="mt-2 ml-2"
                            >
                                <div
                                    class="flex my-2"
                                    v-for="observationType in observationTypesOptions"
                                    :key="observationType.id"
                                >
                                    <input
                                        :id="observationType.id"
                                        class="mr-1 form-checkbox"
                                        type="checkbox"
                                        :value="observationType.id"
                                        v-model="filters.report_types"
                                    />
                                    <label
                                        class="ml-2 font-light text-gray-600"
                                        :for="observationType.id"
                                        >{{ observationType.label }}
                                    </label>
                                </div>
                                <div v-if="filters.report_types.length">
                                    <button
                                        @click.prevent="paginationChangePage"
                                        class="px-6 py-1 mt-2 text-sm font-light tracking-wider text-white bg-green-800 border rounded-md font-sans-secondary"
                                    >
                                        {{ trans.get('strings.plants.apply') }}
                                    </button>
                                    <button
                                        @click.prevent="
                                            filters.report_types = [];
                                            paginationChangePage();
                                        "
                                        class="px-6 py-1 mt-2 text-sm font-light tracking-wider font-sans-secondary"
                                    >
                                        {{ trans.get('strings.plants.clear') }}
                                    </button>
                                </div>
                            </div>
                        </transition>
                    </div>
                    <div class="mb-4 border-b-2"></div>
                    <div class="flex">
                        <input
                            id="budburst_species_only"
                            type="checkbox"
                            class="form-checkbox"
                            value="1"
                            v-model="filters.budburst_species_only"
                        />
                        <label
                            class="ml-2 font-light text-gray-600"
                            for="budburst_species_only"
                        >
                            {{ trans.get('data.budburst_species_only') }}
                        </label>
                    </div>
                    <div class="flex mt-2">
                        <input
                            id="include_youth_observations"
                            type="checkbox"
                            class="form-checkbox"
                            value="1"
                            v-model="filters.include_youth_observations"
                        />
                        <label
                            class="ml-2 font-light text-gray-600"
                            for="include_youth_observations"
                        >
                            {{ trans.get('data.include_youth') }}
                        </label>
                    </div>

                    <div
                        class="flex flex-col px-4 py-8 mt-12 bg-white md:w-75"
                        v-if="!user_id"
                    >
                        <div class="mb-2 text-3xl text-center font-extralight">
                            {{ trans.get('data.join_to_download') }}
                        </div>
                        <div class="mb-6 font-light text-center">
                            {{ trans.get('data.blurb') }}
                        </div>
                        <a
                            class="mx-auto mb-2 btn btn-outline btn-green"
                            :href="`${$prefix}/register`"
                            >{{ trans.get('data.join') }}</a
                        >
                        <a
                            class="text-center underline font-manrope"
                            :href="`${$prefix}/login`"
                        >
                            {{ trans.get('data.sign_in') }}</a
                        >
                    </div>

                    <div
                        class="mt-12"
                        v-if="
                            !loading && list.meta && list.meta.total && user_id
                        "
                    >
                        <h5 class="mb-4 uppercase tracking-loose">
                            {{ trans.get('data.download') }}
                        </h5>
                        <div
                            class="grid grid-cols-1 gap-2 lg:grid-cols-2"
                            v-show="!downloading"
                        >
                            <button
                                class="items-center text-sm lex btn-sm btn btn-solid btn-white btn-tracking"
                                style="z-index: 0 !important"
                                @click="downloadFile('xlsx')"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    class="w-5 h-5"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                    />
                                </svg>
                                <span class="pl-2">Excel</span>
                            </button>
                            <button
                                class="flex items-center text-sm btn-sm btn btn-solid btn-white btn-tracking"
                                style="z-index: 0 !important"
                                @click="downloadFile('csv')"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    class="w-5 h-5"
                                >
                                    <path
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1.5"
                                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                    />
                                </svg>
                                <span class="pl-2">CSV</span>
                            </button>
                        </div>
                        <span v-show="downloading">
                            <i class="fas fa-download fa-spinner fa-spin"></i
                            >{{ trans.get('data.downloading') }}
                            <br />
                        </span>
                    </div>
                    <div class="my-8 border-b-2 lg:hidden"></div>
                </div>
            </transition>
        </div>
        <div class="w-full lg:pl-12">
            <div class="flex-col items-center hidden mb-8 lg:flex-row lg:flex">
                <div class="relative w-full lg:w-2/3">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        class="absolute w-6 h-6 top-3 left-3"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                    </svg>
                    <input
                        type="text"
                        class="w-full form-input"
                        style="padding-left: 3rem !important"
                        id="search_lg"
                        v-model="filters.search"
                        :placeholder="trans.get('data.search_by_name')"
                        autocomplete="off"
                        @keyup.enter="paginationChangePage"
                        @input="paginationChangePage"
                    />
                    <button
                        v-if="filters.search"
                        class="absolute cursor-pointer right-3 top-4"
                        @mousedown.prevent.stop="filters.search = null"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="w-5 h-5"
                            viewBox="0 0 18 18"
                        >
                            <g
                                fill="none"
                                fill-rule="evenodd"
                                stroke="#053633"
                                stroke-width="1.5"
                            >
                                <circle cx="9" cy="9" r="8.325" />
                                <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M5.4,9 L12.6,9 M9,5.4 L9,12.6"
                                    transform="rotate(45 9 9)"
                                />
                            </g>
                        </svg>
                    </button>
                    <div
                        v-show="list.data && !list.data.length"
                        class="absolute w-full px-4 py-3 bg-white top-12"
                    >
                        {{ trans.get('data.no_results') }}
                    </div>
                </div>
            </div>
            <div v-if="!loading && list.data && list.data.length">
                <div class="flex flex-col-reverse justify-between md:flex-row">
                    <div class="mb-4 font-light">
                        {{ list.meta.from.toLocaleString('en') }} -
                        {{ list.meta.to.toLocaleString('en') }} of
                        <span class="px-1 text-3xl lg:text-6xl">{{
                            list.meta.total.toLocaleString('en')
                        }}</span>
                        {{ trans.get('data.observations') }}
                    </div>
                    <!-- <div :class="{ 'hidden md:block': !showSort }">
            <div class="flex flex-col items-center mb-2 md:flex-row w-80">
              <label class="hidden font-light w-18 md:block" for="sortBy">Sort: </label>
              <multiselect
                v-model="filters.sortBy"
                :options="sortByOptions"
                placeholder="Sort by"
                :allow-empty="true"
                :close-on-select="true"
                :show-labels="false"
                @input="paginationChangePage"
                tag-position="top"
              >
              </multiselect>
            </div>
          </div>-->
                </div>
                <div
                    class="grid grid-cols-1 gap-6 lg:grid-cols-3 md:grid-cols-2"
                >
                    <a
                        :href="`${$prefix}/data/${report.id}`"
                        v-for="report in list.data"
                        :key="report.id"
                    >
                        <observation-card
                            :report="report"
                            :user_id="user_id"
                            :is_group="true"
                        ></observation-card>
                    </a>
                </div>
                <pagination
                    :data="list"
                    :limit="3"
                    @pagination-change-page="paginationChangePage"
                    class="flex flex-wrap items-center justify-center my-8"
                >
                    <span slot="prev-nav"
                        >&lt;{{ trans.get('pagination.previous') }}</span
                    >
                    <span slot="next-nav"
                        >{{ trans.get('pagination.next') }}&gt;</span
                    >
                </pagination>
            </div>
        </div>
        <data-download-modal
            v-if="showDataDownloadModal"
            :user_email="user_email"
            @close-modal="closeDataDownloadModal"
        ></data-download-modal>
    </div>
</template>

<script>
import DatePickerTranslations from '../../mixins/datepicker_trans';

export default {
    mixins: [DatePickerTranslations],

    props: {
        plants_options: {
            type: Array,
            required: true
        },
        states_options: {
            type: Array,
            required: true
        },
        user_id: {
            type: Number,
            required: false
        },
        user_email: {
            type: String,
            required: false
        },
        is_limited_member: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            list: {},
            filters: {
                page: 1,
                report_types: [],
                plant_groups: [],
                from_date: null,
                to_date: null,
                state_id: [],
                include_youth_observations: false,
                budburst_species_only: true
            },
            loading: false,
            downloading: false,
            showDataDownloadModal: false,
            from_record: null,
            to_record: null,
            showFilters: false,
            showObservationTypeFilter: false,
            showPlantGroupFilter: false,
            showRegionObservedFilter: false,
            sortByOptions: [
                'Common Name (A-Z)',
                'Common Name (Z-A)',
                'Scientific Name (A-Z)',
                'Scientific Name (Z-A)',
                'Plant Group (A-Z)',
                'Plant Group (Z-A)'
            ],
            showSort: false,
            observationTypesOptions: [
                {
                    id: 'phenology',
                    label: this.trans.get('profile.categories.phenology')
                },
                {
                    id: 'pollinators',
                    label: this.trans.get('profile.categories.pollinator')
                },
                {
                    id: 'monarchs',
                    label: this.trans.get('profile.categories.milkweed')
                }
            ],
            plantGroupsOptions: [
                {
                    id: 'WH',
                    label: this.trans.get('profile.categories.WH')
                },
                {
                    id: 'DTS',
                    label: this.trans.get('profile.categories.DTS')
                },
                {
                    id: 'ETS',
                    label: this.trans.get('profile.categories.ETS')
                },
                {
                    id: 'C',
                    label: this.trans.get('profile.categories.C')
                },
                {
                    id: 'G',
                    label: this.trans.get('profile.categories.G')
                }
            ]
        };
    },

    mounted() {
        this.paginationChangePage();
    },

    methods: {
        paginationChangePage(page = 1) {
            this.filters.page = page;
            this.getResults();
        },

        getDisabledDates(date) {
            const currentDate = new Date();
            const minDate = new Date(2000, 0, 1);
            if (this.filters.from_date && this.filters.to_date) {
                return (
                    date < new Date(this.filters.from_date) ||
                    date > new Date(this.filters.to_date)
                );
            } else if (this.filters.from_date) {
                return (
                    date < new Date(this.filters.from_date) ||
                    date > currentDate ||
                    date < minDate
                );
            } else if (this.filters.to_date) {
                return (
                    date > new Date(this.filters.to_date) ||
                    date > currentDate ||
                    date < minDate
                );
            } else {
                return date > currentDate || date < minDate;
            }
        },

        getResults: function() {
            let vm = this;

            vm.loading = true;

            vm.$nextTick(() => {
                axios.post(`/data/filter`, vm.filters).then(response => {
                    vm.$set(vm, 'list', response.data);
                    vm.loading = false;
                    if (vm.isMobile()) {
                        document.getElementById('search_sm').focus();
                    } else {
                        document.getElementById('search_lg').focus();
                    }
                });
            });
        },

        isMobile: function() {
            if (screen.width < 768) {
                return true;
            } else {
                return false;
            }
        },

        downloadFile(file_type) {
            let vm = this;

            vm.downloading = true;

            let params = vm.filters;

            params.file_type = file_type;
            params.paginate = false;

            axios
                .post('/data/download', params)
                .then(function(response) {
                    vm.showDataDownloadModal = true;
                    vm.downloading = false;
                })
                .catch(function(error) {
                    vm.downloading = false;
                    alert('There was an error dowloading observations');
                });
        },

        closeDataDownloadModal() {
            this.showDataDownloadModal = false;
        },

        clearSelection: function(field_name) {
            this.$set(this.filters, field_name, null);
        },

        formatDate: function(date) {
            return moment(date).format('MM/DD/YYYY');
        }
    },
    watch: {
        'filters.search': function(value) {
            if (!value) {
                this.paginationChangePage();
            }
        },
        'filters.state_id': function(value) {
            if (!value.length) {
                this.paginationChangePage();
            }
        },
        'filters.plant_groups': function(value) {
            if (!value.length) {
                this.paginationChangePage();
            }
        },
        'filters.report_types': function(value) {
            if (!value.length) {
                this.paginationChangePage();
            }
        },
        'filters.include_youth_observations': function(value) {
            this.paginationChangePage();
        },
        'filters.budburst_species_only': function(value) {
            this.paginationChangePage();
        },
        'filters.from_date': function(value) {
            this.paginationChangePage();
        },
        'filters.to_date': function(value) {
            this.paginationChangePage();
        }
    }
};
</script>
